import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import montserratFont from './assets/fonts/Montserrat-VariableFont_wght.woff2';

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';

const fontPreload = document.createElement('link');
fontPreload.rel = 'preload';
fontPreload.as = 'font';
fontPreload.type = 'font/woff2';
fontPreload.href = montserratFont;
fontPreload.crossOrigin = 'anonymous';
document.head.appendChild(fontPreload);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
);
